import script from "./PlatformDynamics.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformDynamics.vue?vue&type=script&setup=true&lang=js"

import "./PlatformDynamics.vue?vue&type=style&index=0&id=4020d768&scoped=true&lang=css"

import exportComponent from "/home/sino/SinoData/jenkins/.jenkins/workspace/enpzjpl/zjpl-cms-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4020d768"]])

export default __exports__